<!-- BRAND -->

<footer class="mt-4 mb-2">
  <div class="row bg-black rounded-4 w-100 py-4 px-2 mx-auto">
    <div class="col-12">
      <div class="copyright text-center text-lg-left text-white">
        &copy; 2025 <a href="#" class="font-weight-bold ml-1 text-white" target="_blank">123 SRL</a>
      </div>
    </div>
  </div>

</footer>